import authorizeService from '../api-authorization/AuthorizeService';
import authorizedFetch, { authorizedPost } from '../api-authorization/AuthorizedFetch';

class UserService {
    _roles = null;

    async hasProfile() {
        var profile = await this.getProfile();
        return profile !== null;
    }

    async getAvailableActivities() {
        var response = await authorizedFetch('api/activities');
        var activities = response.json();

        return activities;
    }

    async getProfile() {
        var response = await authorizedFetch('api/user/profile');
        if(response.status === 204)
            return null;

        return response.json();
    }

    async updateProfile(profile) {
        await authorizedPost('api/user/profile', profile);
    }

    async getHomeData() {
        var response = await authorizedFetch('api/user/home');
        var homeData = await response.json();

        return homeData;
    }

    async getClasses() {
        var response = await authorizedFetch('api/user/classes');
        var classes = await response.json();

        return classes;
    }

    async getSideBar() {
        var response = await authorizedFetch('api/user/sidebar');
        var sideBarData = await response.json();

        return sideBarData;
    }

    async getCheckIns() {
        var response = await authorizedFetch('api/user/check-ins');
        var checkIns = await response.json();

        return checkIns;
    }

    async getDysregulationActivities() {
        var response = await authorizedFetch('api/user/dysregulation-activities');
        var dysregulations = await response.json();

        return dysregulations;
    }

    async getRoles() {
        if(!(await authorizeService.isAuthenticated()))
        {
            return null;
        }

        console.log(this._roles);
        if(this._roles)
        {
            return this._roles;
        }

        var response = await authorizedFetch('api/user/roles');
        if(response.status === 200)
        {
            this._roles = await response.json();
        } else {
            this._roles = null;
        }

        return this._roles;
    }

    async userInRole(roleName) {
        const roles = await this.getRoles();
        return roles && roles.includes(roleName);
    }
}

const userService = new UserService();

export default userService;
